import { DropDownListBaseCustomElement } from 'General/Resources/Elements/DropDownList/DropDownListBase';
import { autoinject, customElement } from 'aurelia-framework';

@autoinject
@customElement('drop-down-list')
export class DropDownListCustomElement extends DropDownListBaseCustomElement {}